import styles from "./OnboardingOrganisation.module.scss";
import { TextField } from "@mui/material";
import classNames from "classnames";
import { useEnumStore } from "../../store/enumStore";
import { Dropzone } from "../Dropzone/Dropzone";
import { EventInterestsSkillsSection } from "../EventInterestsSkillsSection/EventInterestsSkillsSection";
import { FileWithPreview } from "../../types/common";

interface OnboardingOrganisationSecondStepProps {
  title: string;
  desc: string;
  formData: {
    areas: string[];
    organisation_info: string;
  };
  onCheckboxToggle: (id: string, field: "areas") => void;
  onSetFormData: (data: { areas: string[]; organisation_info: string }) => void;
  minTextLength: number;
  remainingCharacters: number;
  files: FileWithPreview[];
  onSetFiles: (files: FileWithPreview[]) => void;
}

export const OnboardingOrganisationSecondStep = ({
  title,
  desc,
  formData,
  onCheckboxToggle,
  onSetFormData,
  minTextLength,
  remainingCharacters,
  files,
  onSetFiles,
}: OnboardingOrganisationSecondStepProps) => {
  const interests = useEnumStore((state) => state.interests);

  return (
    <div className={classNames(styles.content)}>
      <h2>{title}</h2>
      <p>{desc}</p>
      <h3>Okruhy</h3>
      <p className={styles.subtitle}>
        Zvolte prosím alespoň 3 okruhy, ať vaše akce můžeme správně zařadit.
      </p>
      <EventInterestsSkillsSection
        title=""
        items={interests as any}
        selectedIds={formData.areas}
        onToggle={(id) => onCheckboxToggle(id, "areas")}
        editMode={true}
        userType="organisation"
        showSubItems={true}
        type="interests"
      />
      <form className={styles.form}>
        <TextField
          id="organisation_info"
          label="Krátký popis toho, co děláte"
          variant="outlined"
          placeholder="Popis organizace (min. 100 znaků)"
          fullWidth
          multiline
          rows={4}
          value={formData.organisation_info}
          onChange={(e) =>
            onSetFormData({
              ...formData,
              organisation_info: e.target.value,
            })
          }
          helperText={
            formData.organisation_info.length < minTextLength
              ? `Zadejte ještě alespoň ${remainingCharacters} znaků.`
              : "Minimální počet znaků splněn."
          }
        />
        <div className={styles.logo}>
          <p>Logo organizace</p>
          <Dropzone fullWidth files={files} setFiles={onSetFiles} />
        </div>
      </form>
    </div>
  );
};
